import React from "react";
import "../css/delivery.scss";
import PolicyPage from "./PolicyPage";

function Delivery() {
  return (
    <PolicyPage title="Shipping Policy">
      <p><em>Last updated: October 9, 2026</em></p>
      <h2>Shipping Charge</h2>
      <p>A flat shipping charge of <strong>USD 9.99</strong> applies to every order and is shown in the cart and checkout totals.</p>

      <h2>Order Preparation</h2>
      <p>Most orders are prepared within 2–5 business days. A style requiring additional finishing may take longer; if so, we will email you before dispatch. Orders are not processed on Hong Kong public holidays.</p>

      <h2>Delivery Estimates</h2>
      <p>Estimated transit is usually 5–15 business days after dispatch, depending on destination and carrier conditions. Tracking is emailed when available. Estimates are not guaranteed delivery dates.</p>

      <h2>Delivery Destinations</h2>
      <p>Available countries are shown at checkout. We do not accept orders for destinations subject to applicable trade or payment restrictions. If a destination becomes unavailable after purchase, we will cancel and refund the affected order.</p>

      <h2>Address Accuracy</h2>
      <p>Please check the recipient name, email, street address, city and postal code before payment. Contact <a href="mailto:core@danecay.shop">core@danecay.shop</a> immediately if a correction is needed. We cannot guarantee changes after dispatch.</p>

      <h2>Delays, Loss or Damage</h2>
      <p>If tracking has not updated for seven business days, or the parcel arrives damaged, email us with the order number and clear photos where relevant. We will investigate with the carrier and explain the available replacement or refund options.</p>
    </PolicyPage>
  );
}

export default Delivery;
